import React from 'react';
import { Link, withRouter } from "react-router-dom";
import "./Tags.scss";

const Tags = (props) => {
    const gotoPage = (key, type) => {
        if (type === "Blog") {
            props.history.push({
                pathname: "/blog",
                state: { categoryId: null, searchKey: key }
            });
        } else if (type === "Product") {
            props.history.push({
                pathname: "/products",
                state: { categoryId: null, searchKey: key }
            });
        } else {
            return false;
        }
    }
    return (
        <div className="tags">
            <p className="tagTitle">برچسب ها:</p>
            {props.tagData && props.tagData.map((item, index) => {
                return (
                    <span key={index} onClick={() => gotoPage(item.value, item.type)} className="tagLink">{item.value}</span>
                )
            })}
        </div>
    )
}

export default React.memo(withRouter(Tags));
